if (!customElements.get('product-reviews')) {
  customElements.define('product-reviews', class ProductReviews extends HTMLElement {
    constructor() {
      super();
      this.currentPage = 1;
      this.perPage = parseInt(this.getAttribute('per-page'), 10) || 5;

      try {
        const json = document.getElementById('ProductReviewsJSON')?.textContent;
        this.productReviews = json ? JSON.parse(json) : [];
      } catch (e) {
        console.error("Failed to parse reviews JSON:", e);
        this.productReviews = [];
      }

      this.totalPages = Math.ceil(this.productReviews.length / this.perPage);
      this.loadMoreButton = this.querySelector('#ProductReviewsLoadMore');
      this.reviewList = this.querySelector('#ReviewList');

      this._renderCurrentPage();

      this.loadMoreButton?.addEventListener('click', () => {
        this.currentPage++;
        this._renderCurrentPage();
      });
    }

    _renderCurrentPage() {
      const startIndex = (this.currentPage - 1) * this.perPage;
      const endIndex = this.currentPage * this.perPage;
      const reviews = this.productReviews.slice(startIndex, endIndex);

      this.classList.add('loading');
      this.reviewList.insertAdjacentHTML('beforeend', reviews.map((review, i) => this._createReviewHTML(review, i)).join(''));
      this.classList.remove('loading');

      if (this.currentPage >= this.totalPages) {
        this._disablePagination();
      }
    }

    _createReviewHTML(review, index) {
      const dayNames = ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"];
      const monthNames = ["janvier", "février", "mars", "avril", "mai", "juin",
        "juillet", "août", "septembre", "octobre", "novembre", "décembre"];
      const dt = new Date(review.created_at.replace('T', ' '));
      const formattedDate = `${dayNames[dt.getDay()]} ${dt.getDate()} ${monthNames[dt.getMonth()]} ${dt.getFullYear()}`;

      return `
        <review-item class="review-item scroll-trigger animate--slide-in" data-id="${review.id}" data-cascade style="--animation-order: ${index};">
          <div class="review-item__meta">
            <div><b>${review.name}</b></div>
            <div class="review-item__meta-certified">
              <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-certified" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M9.131.233c-2.37 1.383-5.37 2.33-7.634 2.646-.822.115-1.495.79-1.494 1.62l.002.497c-.03 6.043.477 11.332 9.462 14.903a1.45 1.45 0 001.062 0C19.52 16.328 20.032 11.04 20 4.996v-.501c0-.828-.673-1.51-1.491-1.638-2.149-.337-5.282-1.274-7.65-2.628A1.733 1.733 0 009.13.233zm4.577 8.478a1 1 0 00-1.414-1.415L9.001 10.59 7.708 9.297a1 1 0 10-1.414 1.414l2 2.001a1 1 0 001.414 0l4-4.001z"></path>
              </svg> 
              <span>ACHETEUR VÉRIFIÉ</span>
            </div>
          </div>
          <div class="review-item__content">
            <div class="review-item__heading">
              <div class="review-item__rating">
                <div class="rating" role="img" aria-label="${review.rating} sur 5.0 étoiles">
                  <span aria-hidden="true" class="rating-star color-rating-accent" style="--rating: ${review.rating}; --rating-max: 5.0; --rating-decimal: 0;"></span>
                </div>
              </div>
              <!-- <div class="review-item__date">${formattedDate}</div> -->
            </div>
            <div class="review-item__body">
              <h3 class="review-item__title">${review.title}</h3>
              <p>${review.body}</p>
            </div>
          </div>
        </review-item>
      `;
    }

    _disablePagination() {
      this.loadMoreButton?.setAttribute('disabled', '');
      this.loadMoreButton?.classList.add('button--disabled');
      this.querySelector('#ProductReviewsPagination')?.classList.add('hidden');
    }
  });
}
